import React from "react";
import styled from "styled-components";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { colorTheme, textTheme } from "../../../theme";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Header = styled.div`
  color: ${colorTheme.black};
  ${textTheme.h3};
`;

export const ComingSoon = () => {
  return (
    <Container>
      <Header>Coming Soon</Header>
    </Container>
  );
};
